import { deCamelize } from "../functions/utils"
import Excursions from "./Excursions"
import Meals from "./Meals"
import InclusionsModule from "./InclusionsModule"
import Hotel from "./Hotel"
import AirportDetailed from "./AirportDetailed"
import FreeText from "./FreeText"
import ActivityOpportunity from './ActivityOpportunity'

const Inclusions = ({ data, slug }) => {
    return (
        <article id={slug}>
            <h3 className="content_h3">{deCamelize(slug)}</h3>
            {data.map((inc, i) => {
                if (!inc || !inc.fields) return
                const type = inc.sys.contentType.sys.id
                return (
                    <div key={i}>
                        {type === 'hotel' && <Hotel data={[inc]} slug="hotels" />}
                        {type === 'tours' && <Excursions data={inc} slug='excursions' />}
                        {type === 'meals' && <Meals data={inc} slug='meals' />}
                        {type === 'inclusions' && <InclusionsModule data={[inc]} />}
                        {type === 'testFreeText' && <FreeText data={[inc]} slug='additionalInfo' />}
                        {type === 'airport' && <AirportDetailed data={inc} />}
                        {type === 'scubaDivingOpportunity' && <ActivityOpportunity data={[inc]} slug="activityOpportunity" />}
                    </div>
                )
            })}
        </article>
    )
}

export default Inclusions
